module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead1-0f2b0a70fe30180bbc654b03d6ad97e4.jpg";